import { Button } from '@/components/ui/Button';
import { XStack } from '@/components/ui/layout/layout';

export const UsageMembersBar = ({
  activeMembers,
  totalMembers,
  onInviteMember,
}: {
  activeMembers: number;
  totalMembers: number;
  onInviteMember: () => void;
}) => {
  return (
    <XStack className="items-center justify-between rounded-xl border border-border bg-surface px-6 py-4 dark:border-border-strong">
      <XStack className="items-baseline gap-1.5">
        <span className="text-2xl font-semibold tabular-nums text-foreground">
          {activeMembers.toLocaleString()}
        </span>
        <span className="text-sm text-foreground-muted">
          of {totalMembers.toLocaleString()}{' '}
          {totalMembers === 1 ? 'member' : 'members'} active this period
        </span>
      </XStack>
      <Button variant="outline" size="sm" onClick={onInviteMember}>
        Invite member
      </Button>
    </XStack>
  );
};
